import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';

export class CollisionBehaviourComponent extends BaseComponent {
    constructor(){
        super();
        this.componentType = ComponentNames.collisionBehaviorComponent;
    }
    ignoresCollisionWith:Array<BaseComponent>;
    collidesWith:Array<BaseComponent>;
}